export default __webpack_public_path__ + "static/media/trainings.760afb78.svg";